import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import { updateSpace } from 'spaces/store/actions';
import { getActiveSpace } from 'spaces/store/selectors';
import { closeModal } from 'modal/store/actions';
import SpaceForm from './SpaceForm';


const UpdateSpaceModal = ({
  name, space, updateSpace, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>Edit Space</MainTitle>

    <SpaceForm
      space={space}
      onSubmit={(space) => {
        updateSpace(space);
        closeModal(name);
      }}
    />
  </>
);
UpdateSpaceModal.propTypes = {
  name: PropTypes.string.isRequired,
  space: PropTypes.object.isRequired, // eslint-disable-line
  updateSpace: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
});


const mapDispatchToProps = {
  updateSpace,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateSpaceModal);
